const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['blogSearch'] = require('../middleware/blogSearch.js')
middleware['blogSearch'] = middleware['blogSearch'].default || middleware['blogSearch']

middleware['blogSearchRedirect'] = require('../middleware/blogSearchRedirect.ts')
middleware['blogSearchRedirect'] = middleware['blogSearchRedirect'].default || middleware['blogSearchRedirect']

middleware['businessAuthenticated'] = require('../middleware/businessAuthenticated.js')
middleware['businessAuthenticated'] = middleware['businessAuthenticated'].default || middleware['businessAuthenticated']

middleware['endsWithSlash'] = require('../middleware/endsWithSlash.ts')
middleware['endsWithSlash'] = middleware['endsWithSlash'].default || middleware['endsWithSlash']

middleware['notification'] = require('../middleware/notification.js')
middleware['notification'] = middleware['notification'].default || middleware['notification']

middleware['pages/searchUsers'] = require('../middleware/pages/searchUsers.ts')
middleware['pages/searchUsers'] = middleware['pages/searchUsers'].default || middleware['pages/searchUsers']

middleware['redirectToContinueIfBusinessPreview'] = require('../middleware/redirectToContinueIfBusinessPreview.js')
middleware['redirectToContinueIfBusinessPreview'] = middleware['redirectToContinueIfBusinessPreview'].default || middleware['redirectToContinueIfBusinessPreview']

middleware['redirectToTopIfBusinessAccount'] = require('../middleware/redirectToTopIfBusinessAccount.js')
middleware['redirectToTopIfBusinessAccount'] = middleware['redirectToTopIfBusinessAccount'].default || middleware['redirectToTopIfBusinessAccount']

export default middleware
